
//uma tela com campos de formulário: login de acesso e senha de acesso, para o usuário acessar a área de administração do site, onde ele pode gerenciar os produtos, categorias e pedidos do site. A tela deve ter um design simples e intuitivo, com campos de formulário para o usuário inserir seu login e senha, e um botão para enviar as informações. O formulário deve ser validado para garantir que o login e a senha sejam inseridos corretamente antes de permitir o acesso à área de administração.
import axios from 'axios';
import React, { useState } from 'react';
import { decryptPassword, encryptPassword } from '../utils/crypto';
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

function Access() {

    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

        if (login && password) {
            setIsLoading(true);
            // code to send the login and password data to the backend API for validation
            //console.log('Login: ', login);
            //console.log('Password: ', password);
            const dataToSend = {
                login: login,
                password: encryptPassword(password)
            };
            console.log(login);
            console.log(password);
            console.log(dataToSend.login);
            console.log(dataToSend.password); 
            console.log(decryptPassword(dataToSend.login));
            console.log(decryptPassword(dataToSend.password));
            setIsLoading(false); 
            //return;
            //return;
            //valida se existe o login usando o method endpoint validateTaxPayerEmail, 
            // se a mensagem de retorno for "Email already exists" 
            // continua e chama o método endpoint validateTaxPayerEmailPass para validar 
            // se o login e senha estão corretos, se a mensagem de retorno for 
            // "Access granted" redireciona para a área de administração, 
            // caso contrário exibe a mensagem de erro retornada pela API.
            // caso contrário se a mensageem do primeiro retorno for diferente de "Email already exists" 
            // enncaminha para a página de registro.

            //valida se existe o email usando o method endpoint validateTaxPayerEmail, 
            axios
            .post(process.env.REACT_APP_API_URL + `/routes.php?method=validateTaxPayerEmail`, 
                { login: login },
                { headers: { 
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8' 
                } 
                })
            .then(response => {
                //se a mensagem de retorno for "Email already exists" continua 
                // e chama o método endpoint validateTaxPayerEmailPass 
                // para validar se o login e senha estão corretos, 
                // se a mensagem de retorno for "Access granted" redireciona 
                // para a área de administração, caso contrário exibe a mensagem de erro retornada pela API.

                if(response.data && response.data.Message && response.data.Message === 'Email already exists') {
                    //valida o email e senha
                    //console.log('Email exists, validating password...' + response.data.Message);
                    //return;
                    axios
                    .post(process.env.REACT_APP_API_URL + `/routes.php?method=validateTaxPayerEmailPass`, 
                        dataToSend,
                        { headers: { 
                            'X-Access-Token' : tokenAPI,
                            'Content-Type': 'application/json; charset=UTF-8' 
                        } 
                        })
                    .then(response => {
                        if(response.data && response.data.Message && response.data.Message === 'Access granted') {
                            axios
                            .post(process.env.REACT_APP_API_URL + `/routes.php?method=validateTaxPayer`, 
                                dataToSend,
                                { headers: { 
                                    'X-Access-Token' : tokenAPI,
                                    'Content-Type': 'application/json; charset=UTF-8' 
                                } 
                                })
                            .then(response => {
                                if(response.data && response.data.Message && response.data.Message !== 'Access granted') {
                                    alert(response.data.Message);
                                    setIsLoading(false);
                                    if(response.data && response.data.IdTaxPayer && parseInt(response.data.IdTaxPayer) > 0) {
                                        sessionStorage.setItem('IdTaxPayer', response.data.IdTaxPayer);
                                        sessionStorage.setItem('txpCodeGUID', response.data.txpCodeGUID);
                                        navigate(`/TaxPayer/${response.data.txpCodeGUID}`);
                                    }
                                    else {
                                        navigate('/Register/0');
                                    }
                                } else {
                                    if(response.data && response.data.IdTaxPayer && parseInt(response.data.IdTaxPayer) > 0) {
                                        sessionStorage.setItem('IdTaxPayer', response.data.IdTaxPayer);
                                        sessionStorage.setItem('txpCodeGUID', response.data.txpCodeGUID);
                                        navigate(`/TaxPayer/${response.data.txpCodeGUID}`);
                                    }
                                    setIsLoading(false);
                                }
                                // Here you can add the logic to handle the response from the backend API
                                // For example, if the response indicates that the login and password are valid, you can redirect the user to the administration area
                            })
                            .catch(error => {
                                alert('Error validating access: ' + JSON.stringify(error.message));
                                setIsLoading(false);
                                // Here you can add the logic to handle any errors that occur during the API request
                            });
                        } else {
                            alert(response.data.Message);
                        }
                        setIsLoading(false);
                    })
                    .catch(error => {
                        alert('Error validating access: ' + JSON.stringify(error.message));
                        setIsLoading(false);
                    });
                } else {
                    //email não existe, encaminha para registro
                    console.log(response.data.Message); return;
                    navigate('/Register/0');
                }
            })
            .catch(error => {
                alert('Error validating access: ' + JSON.stringify(error.message));
                setIsLoading(false);
            });
        } else {
            alert('Please enter both login and password!');
        }
    };

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div>
                        <label>Sign into or create your account</label>
                    </div>
                </div>
                <div className='headerMain'>
                    <div className="w100 mt2">
                        <form onSubmit={handleSubmit}>
                            <div className='d-flex w100 flex-column tdAlignLeft pb2'>
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelContent'>Enter your username, email or mobile number to get started:</label>
                                </div>
                                <div className='text-align-left divForm fs14'>
                                    <input
                                        type="text"
                                        className="p1 fs12 w100 text-align-left borderRadius"
                                        value={login} 
                                        autoComplete="off"
                                        onChange={(e) => setLogin(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className='d-flex w100 flex-column tdAlignLeft pb2'>
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelContent'>Password:</label>
                                </div>
                                <div className='text-align-left divForm fs14'>
                                    <input
                                        type="password"
                                        className="p1 fs12 w100 text-align-left borderRadius"
                                        value={password} 
                                        autoComplete="off"
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            {isLoading ? (
                                <div className='d-flex w100 justify-content-center mt2 mb4'>
                                    <CircularProgress />
                                </div>
                            ) : (
                            <button type="submit" className=' mt2 mb4 p1 borderRadius fs12' style={{ textDecoration: 'none', cursor: 'pointer' }}>Continue or Create Account</button>
                            )}
                        </form>
                    </div>
                </div>
            </main>
            
        </div>
    );
}

export default Access;